import React from 'react';
import { Box, IconButton, Stack, TextField, Typography } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import { Draggable } from 'react-beautiful-dnd';

function WhiteList({
  whitelist,
  editingId,
  editingUrl,
  setEditingId,
  setEditingUrl,
  onSave,
  onDelete,
}) {
  return whitelist.map((item, index) => (
    <Draggable key={item._id} draggableId={String(item._id)} index={index}>
      {(provided, snapshot) => (
        <div ref={provided.innerRef} {...provided.draggableProps}>
          <Box
            sx={{
              mb: 1,
              px: 1.75,
              py: 1.25,
              borderRadius: '10px',
              border: '1px solid rgba(19,148,127,0.22)',
              backgroundColor: '#ffffff',
              boxShadow: snapshot.isDragging ? '0 16px 32px -12px rgba(11,46,67,0.25)' : 'none',
              transition: 'border-color 140ms ease',
              '&:hover': {
                borderColor: 'rgba(19,148,127,0.45)',
              },
            }}
          >
            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1.5}>
              <Stack
                direction="row"
                alignItems="center"
                spacing={1.25}
                sx={{ flex: 1, minWidth: 0 }}
                {...provided.dragHandleProps}
              >
                <VerifiedOutlinedIcon sx={{ color: '#13947F', fontSize: 19, flexShrink: 0 }} />
                {editingId === item._id ? (
                  <form onSubmit={(event) => onSave(item._id, event)} style={{ flex: 1 }}>
                    <TextField
                      value={editingUrl}
                      onChange={(event) => setEditingUrl(event.target.value)}
                      autoFocus
                      fullWidth
                      size="small"
                      label="Edit allowlist entry"
                    />
                  </form>
                ) : (
                  <Typography
                    sx={{ color: '#244657', fontWeight: 600, fontSize: '0.92rem', wordBreak: 'break-all', cursor: 'text' }}
                    onDoubleClick={() => { setEditingId(item._id); setEditingUrl(item.url); }}
                    title="Double-click to edit"
                  >
                    {item.url}
                  </Typography>
                )}
              </Stack>
              <IconButton size="small" onClick={() => onDelete(item._id)} aria-label="Delete allowlist entry">
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            </Stack>
          </Box>
        </div>
      )}
    </Draggable>
  ));
}

export default WhiteList;
